const tintColor = "#2f95dc";

export default {
  tintColor,
  tabIconDefault: "#ccc",
  tabIconSelected: tintColor,
  tabBar: "#fefefe",
  errorBackground: "red",
  errorText: "#fff",
  warningBackground: "#EAEB5E",
  warningText: "#666804",
  noticeBackground: tintColor,
  noticeText: "#fff",
};

export const lightColors = {
  background: "#FFFFFF",
  primary: "#512DA8",
  text: "#121212",
  error: "#D32F2F",
  vectorColor: "rgba(0,0,0,0.35)",
  secondary: "#fdfdfd",
  tertiary: "#e8e8e8",
  secondaryBorderColour: "#ededed",
};

/**
 * Dark theme
 */
export const darkColors = {
  // background: "#121212",
  background: "#353634",
  primary: "#B39DDB",
  text: "#FFFFFF",
  error: "#EF9A9A",
  vectorColor: "rgb(255,255,255)",
  secondary: "#3d3d3d",
  tertiary: "#707070",
  secondaryBorderColour: "#2e2e2e",
};

export function shadeColor(color, percent) {
  var R = parseInt(color.substring(1, 3), 16);
  var G = parseInt(color.substring(3, 5), 16);
  var B = parseInt(color.substring(5, 7), 16);
  R = parseInt(R * (100 + percent) / 100);
  G = parseInt(G * (100 + percent) / 100);
  B = parseInt(B * (100 + percent) / 100);
  R = (R < 255) ? R : 255;
  G = (G < 255) ? G : 255;
  B = (B < 255) ? B : 255;
  var RR = ((R.toString(16).length == 1) ? "0" + R.toString(16) : R.toString(16));
  var GG = ((G.toString(16).length == 1) ? "0" + G.toString(16) : G.toString(16));
  var BB = ((B.toString(16).length == 1) ? "0" + B.toString(16) : B.toString(16));
  return "#" + RR + GG + BB;
}
